import styled from 'styled-components';

export const MainContainer = styled.div`
    height: 100%;
    min-height: 100vh;
    width: 100%;
    background-color: ${({theme}) => theme.background_main_grey};
`;

export const InnerContainer = styled.div`
    position: relative;
    max-width: 192rem;
    width: 100%;
    padding: 1rem 1rem 1rem;
    margin: 0 auto;
`;

export const HeaderWrapper = styled.div`
    .p-dialog-header {
        margin-top: 20px;
    }

    h1 {
        font-size: 20px;
        color: ${({theme}) => theme.color_black};
        display: contents;
    }
`;